// Types metier Autodiag SCOP - V6
/**
 * Calcule le nombre de casques a afficher et l'eligibilite au 5eme casque.
 * Le 5eme casque n'est affiche que si une attestation validee avec badgeDore existe.
 */
export function getCasquesAffiches(resultatCasques, attestation) {
    const attestationValidee = attestation?.statut === 'validee' && attestation?.badgeDore;
    if (resultatCasques === 5 && !attestationValidee) {
        return { casques: 4, badgeDore: false, eligible5eme: true };
    }
    return {
        casques: resultatCasques,
        badgeDore: attestationValidee || false,
        eligible5eme: false,
    };
}
// V7: 5 casques (1-5) + badge doré MASE — seuils officiels OPPBTP
export const SEUILS_CASQUES = {
    1: [
        { min: 0, max: 15 }, // 1 casque
        { min: 16, max: 44 }, // 2 casques
        { min: 45, max: 72 }, // 3 casques
        { min: 73, max: 100 }, // 4 casques
        { min: 101, max: Infinity }, // 5 casques
    ],
    2: [
        { min: 0, max: 24 },
        { min: 25, max: 71 },
        { min: 72, max: 118 },
        { min: 119, max: 165 },
        { min: 166, max: Infinity },
    ],
    3: [
        { min: 0, max: 33 },
        { min: 34, max: 98 },
        { min: 99, max: 163 },
        { min: 164, max: 228 },
        { min: 229, max: Infinity },
    ],
};
/** Calcule le nombre de casques (1-5) a partir du score et du nombre de metiers */
export function getCasques(score, metierCount) {
    const clamped = Math.min(Math.max(metierCount, 1), 3);
    const seuils = SEUILS_CASQUES[clamped];
    for (let i = seuils.length - 1; i >= 0; i--) {
        if (score >= seuils[i].min)
            return (i + 1);
    }
    return 1;
}
//# sourceMappingURL=types.js.map